import { api } from '@/lib/api/api';
import { useQuery } from '@tanstack/react-query';

interface UseResourceArgs {
  id: string;
}

export default function useResource(
  { id }: UseResourceArgs,
  {
    enabled = true
  }: {
    enabled?: boolean;
  } = {
    enabled: true
  }
) {
  const { data: resource, error } = useQuery(
    ['organizations.resource', id],
    async () => {
      const res = await api.client.organizations.resourceGet(id);
      return res.result?.resource;
    },
    {
      enabled
    }
  );

  const loading = !resource && !error;
  return { resource, error, loading };
}
